import { Typography } from '@material-ui/core';
import { Link } from 'gatsby';
import React from 'react';
import { Headline } from '../components/Headline';
import PageHead from '../components/PageHead';
import { SEO } from '../components/SEO';
import MainLayout from '../layouts/main';
import styled from '../styled';

const StyledLink = styled(Link)`
  color: ${(p) => p.theme.palette.primary.main};
  border-bottom: 1px solid;
`;

const LogosWrapper = styled('div')`
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: ${(p) => p.theme.spacing(3)}px;
  grid-row-gap: ${(p) => p.theme.spacing(3)}px;
  align-items: center;
  justify-content: center;
`;

const LogoContainer = styled('div')`
  position: relative;
  display: grid;
  align-items: center;
  justify-content: center;
  border: 1px solid #f5f4f4;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.03);
  border-radius: ${(p) => p.theme.shape.borderRadius}px;
  padding: ${(p) => p.theme.spacing(8)}px ${(p) => p.theme.spacing(4)}px;
`;

const Integrations = styled('div')`
  text-align: center;
  width: 100%;
  margin: 0 auto;
  color: #333;
  max-width: 1000px;
  width: 80%;
  padding: 24px;
`;

export default () => (
  <MainLayout>
    <div>
      <SEO
        pathname="/partners/"
        title="Partner with Us"
        description="Partner with Affilimate as an integrator, publisher partner, or affiliate promoter."
      />
      <PageHead style={{ marginBottom: 0 }}>
        <Headline variant="h2" component="h1" style={{ fontWeight: 900 }}>
          Partner with Affilimate
        </Headline>
        <Typography
          paragraph
          style={{ maxWidth: '500px', padding: '24px', margin: '0 auto' }}
        >
          Affilimate gives publishers and brands the tools they need to grow
          their revenue through commerce.
        </Typography>
      </PageHead>
      <Integrations style={{ marginBottom: '24px' }}>
        <div style={{ marginBottom: '48px' }}>
          <LogosWrapper>
            <LogoContainer>
              <Typography variant="body2" color="textSecondary">
                Explore partnership opportunities with us by{' '}
                <StyledLink to="/contact/">
                  filling out our contact form
                </StyledLink>
              </Typography>
            </LogoContainer>
          </LogosWrapper>
        </div>
      </Integrations>
    </div>
  </MainLayout>
);
